import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';

import Logo from 'components/common/Logo';
import Section from 'components/common/Section';
import Flex from 'components/common/Flex';

import auth from 'api/core/auth';
import authApi from 'api/modules/authApi';
import meApi from 'api/modules/meApi';
import paths from 'routes/paths';
import { useUserContext } from '../../providers/UserProvider';

const Login = () => {
  const { refresh } = useUserContext();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const handleSubmit = async e => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const loginResponse = await authApi.login({
        email: formData.email,
        password: formData.password,
      });

      auth.setAuth(loginResponse);

      refresh(); // Trigger UserProvider to fetch user and redirect
    } catch (error) {
      console.error('[Login.js] handleSubmit error', error);
      auth.clearAuth();
      toast.error(error.message || 'Login failed. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleFieldChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const isFormValid = formData.email && formData.password;

  return (
    <Section className="py-0">
      <Row className="flex-center min-vh-100 py-6">
        <Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4">
          <Logo />
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <Flex
                justifyContent="between"
                alignItems="center"
                className="mb-2"
              >
                <h5>Log in</h5>
              </Flex>
              <Form onSubmit={handleSubmit}>
                <Form.Group className="mb-3">
                  <Form.Control
                    placeholder="Email"
                    value={formData.email}
                    name="email"
                    onChange={handleFieldChange}
                    type="email"
                    required
                  />
                </Form.Group>

                <Form.Group className="mb-3">
                  <Form.Control
                    placeholder="Password"
                    value={formData.password}
                    name="password"
                    onChange={handleFieldChange}
                    type="password"
                    required
                  />
                </Form.Group>

                <Row className="justify-content-end">
                  <Col xs="auto">
                    <Link className="fs-10 mb-0" to={paths.passwordReset}>
                      Forgot Password?
                    </Link>
                  </Col>
                </Row>

                <Form.Group>
                  <Button
                    type="submit"
                    color="primary"
                    className="mt-3 w-100"
                    disabled={!isFormValid || isLoading}
                  >
                    {isLoading ? 'Logging in...' : 'Log in'}
                  </Button>
                </Form.Group>
              </Form>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Section>
  );
};

export default Login;
